module.exports = __webpack_public_path__ + "static/img/Header_1920x380_Y.8c66192.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/y-chromosome-dna-test/Header_1920x380_Y.jpg
// module id = ekO0
// module chunks = 0